import { createContext, ReactNode, useContext } from 'react'

type User = {
  id: string
  name?: string
  email?: string
}

type AnnotationsContextState = {
  currentUser: User | undefined
  users: User[]
}

const AnnotationsContext = createContext<AnnotationsContextState | undefined>(undefined)

type Props = {
  children: ReactNode
  currentUser: User | undefined
  users: User[]
}
export function AnnotationsProvider({ children, currentUser, users }: Props) {
  return (
    <AnnotationsContext.Provider value={{ currentUser, users }}>
      {children}
    </AnnotationsContext.Provider>
  )
}

export function useAnnotationsContext(): AnnotationsContextState {
  const context = useContext(AnnotationsContext)
  if (context === undefined) {
    throw new Error('You must have an AnnotationsProvider which provides users and currentUser')
  }
  return context
}
